var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12C11.75 14.619 9.619 16.75 7 16.75C4.381 16.75 2.25 14.619 2.25 12C2.25 9.381 4.381 7.25 7 7.25C9.619 7.25 11.75 9.381 11.75 12ZM12 7.25C11.72 7.25 11.43 7.28 11.15 7.33C12.44 8.47 13.25 10.14 13.25 12C13.25 13.86 12.44 15.53 11.15 16.67C11.43 16.72 11.72 16.75 12 16.75C14.62 16.75 16.75 14.62 16.75 12C16.75 9.38 14.62 7.25 12 7.25ZM17.5 7.52C17.16 7.52 16.82 7.56 16.49 7.66C17.58 8.78 18.25 10.32 18.25 12C18.25 13.68 17.58 15.22 16.49 16.34C16.82 16.44 17.16 16.48 17.5 16.48C19.84 16.48 21.75 14.47 21.75 12C21.75 9.53 19.84 7.52 17.5 7.52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/animation.de0fb88b4bd3d21cfb0f18f1619610d5.svg";
export { ForwardRef as ReactComponent };